import { render, staticRenderFns } from "./userSuggest.vue?vue&type=template&id=0afd4616&"
import script from "./userSuggest.vue?vue&type=script&lang=ts&"
export * from "./userSuggest.vue?vue&type=script&lang=ts&"
import style0 from "./userSuggest.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports